import { render, staticRenderFns } from "./TradeInChangeStatus.vue?vue&type=template&id=2b5b1c4b&scoped=true"
import script from "./TradeInChangeStatus.vue?vue&type=script&lang=js"
export * from "./TradeInChangeStatus.vue?vue&type=script&lang=js"
import style0 from "./TradeInChangeStatus.vue?vue&type=style&index=0&id=2b5b1c4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5b1c4b",
  null
  
)

export default component.exports